<template>
  <div>
    <div class="container">
      <div class="flex vx-row">
        <div
          class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-8/12 xl:w-8/12 padding-2"
        >
          <div class="bg-white rounded-xl p-6 mt-5">
            <div class="mb-6">
              <div class="flex items-center justify-between mb-3">
                <div class="flex items-center gap-3">
                  <h3 class="text-[15px] font-medium">
                    {{ $t("customers.label.CustomerInfo") }}
                  </h3>
                </div>
              </div>
              <ValidationObserver ref="customerInfoObserver">
                <div
                  v-for="section in basketData.simType === 'Prepaid'
                    ? prepaidSections
                    : sections"
                  :key="section.id"
                  class="mb-4"
                >
                  <div
                    class="flex justify-between items-center cursor-pointer bg-gray-100 p-2 rounded-lg"
                    @click="toggleSection(section.id)"
                  >
                    <span class="font-medium">{{ section.title }}</span>
                    <span>
                      <feather-icon
                        :icon="section.open ? 'MinusIcon' : 'PlusIcon'"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current"
                        class="ml-2"
                      />
                    </span>
                  </div>
                  <div
                    v-show="section.id === 1 && section.open"
                    class="p-2 rounded-lg"
                  >
                    <div class="grid grid-cols-2 gap-4">
                      <div>
                        <div class="dropdown-with-label">
                          <small class="date-label"
                            >{{ $t("customers.label.title") }}
                            <span class="required">*</span></small
                          >
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            :name="$t('customers.label.title')"
                          >
                            <v-select
                              label="label"
                              v-model="clientData.title"
                              :options="titleOptions"
                              :placeholder="$t('customers.label.SelectTitle')"
                              :reduce="(obj) => obj.value"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                              class="min-w-200 w-full"
                            />
                            <span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div>
                        <ValidationProvider
                          rules="required|alpha"
                          v-slot="{ errors }"
                          :name="$t('customers.label.initials')"
                        >
                          <vs-input
                            type="text"
                            :label="$t('customers.label.initials')"
                            v-model="customerForm.initials"
                            class="w-full font-semibold starlabel mb-2"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                      <div>
                        <ValidationProvider
                          rules="required|alpha"
                          v-slot="{ errors }"
                          :name="$t('customers.label.first_name')"
                        >
                          <vs-input
                            type="text"
                            :label="$t('customers.label.first_name')"
                            v-model="clientData.firstname"
                            class="w-full font-semibold starlabel mb-2"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                      <div>
                        <ValidationProvider
                          rules="required|alpha"
                          v-slot="{ errors }"
                          :name="$t('customers.label.last_name')"
                        >
                          <vs-input
                            type="text"
                            :label="$t('customers.label.last_name')"
                            v-model="clientData.lastname"
                            class="w-full font-semibold starlabel mb-2"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                      <div>
                        <ValidationProvider
                          rules="required|email"
                          v-slot="{ errors }"
                          :name="$t('customers.label.email_address')"
                        >
                          <vs-input
                            type="text"
                            :label="$t('customers.label.email_address')"
                            v-model="clientData.email"
                            class="w-full font-semibold starlabel mb-2"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                      <div>
                        <ValidationProvider
                          rules="required|numeric|max:10"
                          v-slot="{ errors }"
                          :name="$t('customers.label.contact_number')"
                        >
                          <vs-input
                            type="text"
                            :label="$t('customers.label.contact_number')"
                            v-model="clientData.phone"
                            class="w-full font-semibold starlabel mb-2"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                      <div>
                        <div class="dropdown-with-label">
                          <small class="date-label"
                            >{{ $t("customers.label.date_of_birth") }}
                            <span class="required">*</span></small
                          >
                          <ValidationProvider
                            rules="required|adult"
                            v-slot="{ errors }"
                            :name="$t('customers.label.date_of_birth')"
                          >
                            <Datepicker
                              placeholder="Select Date"
                              v-model="clientData.dateOfBirth"
                              class="mt-1 font-semibold"
                            />
                            <span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div>
                        <div class="dropdown-with-label">
                          <small class="date-label"
                            >{{ $t("customers.label.select_language") }}
                            <span class="required">*</span></small
                          >
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            :name="$t('customers.label.select_language')"
                          >
                            <v-select
                              label="mCodeValue"
                              v-model="customerForm.language"
                              :options="preferredLanguages"
                              :placeholder="
                                $t('customers.label.select_language')
                              "
                              :reduce="(obj) => obj.mCodeValue"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                              class="min-w-200 w-full"
                            />
                            <span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                      <div>
                        <div class="dropdown-with-label">
                          <small class="date-label"
                            >{{ $t("customers.label.how_did_you_hear") }}
                            <span class="required">*</span></small
                          >
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            :name="$t('customers.label.how_did_you_hear')"
                          >
                            <v-select
                              label="mCodeValue"
                              v-model="customerForm.referral"
                              :options="sourceTypes"
                              :placeholder="$t('customers.label.SelectTitle')"
                              :reduce="(obj) => obj.mCodeValue"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                              class="min-w-200 w-full"
                            />
                            <span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-show="section.id === 2 && section.open"
                    class="mt-3 p-4 rounded-lg"
                  >
                    <form @submit.prevent="submitForm">
                      <div
                        class="address-form"
                        v-if="
                          !show && (!addressList || addressList.length === 0)
                        "
                      >
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('customers.label.postal_code')"
                        >
                          <vs-input
                            type="text"
                            :label="$t('customers.label.postal_code')"
                            v-model="postcode"
                            class="w-full font-semibold starlabel mb-2"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('customers.label.country')"
                        >
                          <vs-input
                            type="text"
                            :label="$t('customers.label.country')"
                            v-model="countryName"
                            class="w-full font-semibold starlabel mb-2"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                        <a
                          class="manual-entry cursor-pointer"
                          @click="enterAddressManually"
                        >
                          {{ $t("customers.label.Enter_address_manually") }}
                        </a>
                        <vs-button
                          block
                          color="success"
                          class="mt-4 ml-4"
                          size="small"
                          @click="fetchAddressList"
                        >
                          {{ $t("customers.label.Find_address") }}
                        </vs-button>
                      </div>
                      <div
                        class="address-form"
                        v-if="addressList && addressList.length > 0"
                      >
                        <label class="block font-medium mb-1">{{
                          $t("customers.label.Select_Address")
                        }}</label>
                        <select
                          v-model="selectedAddress"
                          @change="populateAddressFields"
                          class="w-full mb-4 border-gray-300 rounded-lg"
                        >
                          <option value="Select an address" disabled selected>
                            {{ $t("customers.label.Select_an_address") }}
                          </option>
                          <option
                            v-for="(address, index) in addressList"
                            :key="index"
                            :value="address"
                          >
                            {{ address.Street }} {{ address.House }}
                            {{ address.AddOn }}, {{ address.PostalCode }}
                            {{ address.City }}
                            {{ address.Country }}
                          </option>
                        </select>
                        <a
                          v-if="selectedAddress != 'Select an address'"
                          class="manual-entry"
                          @click="enterAddressDynamically"
                        >
                          {{ $t("customers.label.Enter_address_dynamically") }}
                        </a>
                      </div>
                      <div
                        v-if="selectedAddress != 'Select an address' || show"
                        class="grid grid-cols-2 gap-4"
                      >
                        <div>
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            :name="$t('customers.label.address_number')"
                          >
                            <vs-input
                              type="text"
                              :label="$t('customers.label.address_number')"
                              v-model="addressObj.addressNo"
                              class="w-full font-semibold starlabel mb-2"
                            />
                            <span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                        <div>
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            :name="$t('customers.label.street')"
                          >
                            <vs-input
                              type="text"
                              :label="$t('customers.label.street')"
                              v-model="addressObj.district"
                              class="w-full font-semibold starlabel mb-2"
                            />
                            <span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                        <div>
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            :name="$t('customers.label.postal_code')"
                          >
                            <vs-input
                              type="text"
                              :label="$t('customers.label.postal_code')"
                              v-model="addressObj.zipCode"
                              class="w-full font-semibold starlabel mb-2"
                            />
                            <span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                        <div>
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            :name="$t('customers.label.city')"
                          >
                            <vs-input
                              type="text"
                              :label="$t('customers.label.city')"
                              v-model="addressObj.city"
                              class="w-full font-semibold starlabel mb-2"
                            />
                            <span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                        <div>
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            :name="$t('customers.label.state')"
                          >
                            <vs-input
                              type="text"
                              :label="$t('customers.label.state')"
                              v-model="addressObj.state"
                              class="w-full font-semibold starlabel mb-2"
                            />
                            <span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                        <div>
                          <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            :name="$t('customers.label.country')"
                          >
                            <vs-input
                              type="text"
                              :label="$t('customers.label.country')"
                              v-model="addressObj.country"
                              class="w-full font-semibold starlabel mb-2"
                            />
                            <span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                        <div>
                          <ValidationProvider
                            :rules="
                              basketData.simType === 'Postpaid'
                                ? 'required'
                                : ''
                            "
                            v-slot="{ errors }"
                            :name="$t('customers.label.resident_period')"
                          >
                            <vs-input
                              type="text"
                              :label="$t('customers.label.resident_period')"
                              v-model="addressObj.residentPeriod"
                              class="w-full font-semibold mb-2"
                              :class="{
                                starlabel: basketData.simType === 'Postpaid',
                              }"
                            />
                            <span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </ValidationProvider>
                        </div>
                        <a
                          class="manual-entry cursor-pointer mt-6"
                          @click="enterAddressDynamically"
                        >
                          {{ $t("customers.label.Enter_address_dynamically") }}
                        </a>
                      </div>
                    </form>
                  </div>
                  <div
                    v-show="section.id === 3 && section.open"
                    class="p-2 rounded-lg"
                  >
                    <form @submit.prevent="submitForm">
                      <div class="grid gap-4">
                        <div>
                          <div class="vx-card p-4">
                            <div class="vx-row">
                              <div class="vx-col w-full">
                                <h3 class="ml-1 mb-3">
                                  {{ $t("customers.label.Spend_Cap_Amount") }}
                                </h3>
                                <vs-checkbox
                                  v-model="wantSpendCap"
                                  @input="changeSpendCapType"
                                  class="mb-3"
                                  color="success"
                                >
                                  {{
                                    $t(
                                      "customers.label.I_don’t_want_a_Spend_Cap"
                                    )
                                  }}</vs-checkbox
                                >
                              </div>
                              <div class="vx-col w-full" v-if="!wantSpendCap">
                                <div class="amount-selector">
                                  <div
                                    v-for="(amount, index) in amounts"
                                    :key="index"
                                    class="amount-box"
                                    :class="{
                                      selected: selectedAmount === amount.value,
                                    }"
                                    @click="selectAmount(amount.value)"
                                  >
                                    {{ basketData.planData[0].currencySymbol }}
                                    {{ amount.label }}
                                  </div>
                                </div>
                              </div>
                              <div
                                v-else
                                class="cap-bg text-sm p-4 m-4 rounded-sm"
                              >
                                {{ $t("customers.label.YouHaveChosenNoCap") }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div></div>
                      </div>
                    </form>
                  </div>
                  <div
                    v-show="section.id === 4 && section.open"
                    class="p-2 rounded-lg"
                  >
                    <form @submit.prevent="submitForm">
                      <div class="grid gap-4">
                        <div>
                          <div class="vx-card p-4 billGenerationSection">
                            <div class="vx-row">
                              <div class="vx-col w-full">
                                <h3 class="ml-1 mb-3">
                                  {{
                                    $t(
                                      "customers.label.Monthly_Bill_Generation_Date"
                                    )
                                  }}
                                </h3>
                                <p class="mb-3">
                                  {{ $t("customers.label.SelectDate") }}
                                </p>
                                <div class="dropdown-with-label">
                                  <small class="date-label"
                                    >{{ $t("customers.label.billing_cycle") }}
                                    <span class="required">*</span></small
                                  >
                                  <ValidationProvider
                                    :rules="
                                      basketData.simType === 'Postpaid'
                                        ? 'required'
                                        : ''
                                    "
                                    v-slot="{ errors }"
                                    :name="$t('customers.label.billing_cycle')"
                                  >
                                    <v-select
                                      label="billCycleName"
                                      class="custom-select-title"
                                      v-model="billGenerationDate"
                                      :placeholder="
                                        $t('customers.label.SelectBilling')
                                      "
                                      :clearable="false"
                                      :options="billCycles"
                                      :reduce="(text) => text.id"
                                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                    />
                                    <span
                                      class="validate-error"
                                      style="color: red"
                                      >{{ errors[0] }}</span
                                    >
                                  </ValidationProvider>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div></div>
                      </div>
                    </form>
                  </div>
                </div>
              </ValidationObserver>
              <!-- Terms & Conditions -->
              <div class="mt-4">
                <label class="flex items-center gap-2">
                  <input type="checkbox" v-model="termsAccepted" />
                  <span
                    >{{ $t("customers.label.I_Agree_To") }}
                    <a href="#" @click="termCondtionPopup = true">{{
                      $t("customers.label.TermsAndConditions")
                    }}</a></span
                  >
                </label>
              </div>

              <div class="centerx">
                <vs-popup
                  :title="$t('customers.label.TermsAndConditions')"
                  :active.sync="termCondtionPopup"
                  class="popup-close large-popup"
                >
                  <TermsAndConditions />
                </vs-popup>
              </div>
            </div>
          </div>
        </div>
        <div
          class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-4/12 xl:w-4/12 padding-2"
        >
          <div class="vx-card p-4">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div class="flex items-center basketSection">
                  <img src="@/assets/images/pages/basketIcon.svg" />
                  <h3 class="ml-3">{{ $t("customers.label.Basket") }}</h3>
                </div>
              </div>
            </div>
            <div>
              <div
                class="p-2"
                :style="
                  (basketData && basketData.pairedItemSerialNumber) ||
                  (basketData && basketData.serialNumber.length > 14)
                    ? {
                        border:
                          elapsedTime > 59
                            ? '4px solid #00FF00'
                            : '4px solid #FF0000',
                      }
                    : {}
                "
              >
                <span
                  class="font-bold flex items-center justify-between"
                  v-if="
                    (basketData && basketData.pairedItemSerialNumber) ||
                    (basketData && basketData.serialNumber.length > 14)
                  "
                >
                  {{ $t("customers.label.This_number_is_reserved_for") }}
                  <Timer
                    @update-timer="updateElapsedTime"
                    :elapsedTime="elapsedTime"
                  />
                </span>
                <p class="mb-2 text-success">
                  ✅ You Selected {{ basketData.selectedSimText }}
                </p>
                <!-- <p v-if="basketData.itemSerialNumber" class="mb-2 text-success">
                  ✅ Serial No - {{ basketData.itemSerialNumber }}
                </p>
                <p
                  v-if="basketData.pairedItemSerialNumber"
                  class="mb-2 text-success"
                >
                  ✅ Phone No - {{ basketData.pairedItemSerialNumber }}
                </p>
                <p
                  v-if="
                    basketData.simType === 'Postpaid' &&
                    basketData.serialNumber.length > 12
                  "
                  class="mb-2 text-success"
                >
                  ✅ Serial No - {{ basketData.serialNumber }}
                </p>
                <p
                  v-if="
                    basketData.simType === 'Postpaid' && basketData.phoneNumber
                  "
                  class="mb-2 text-success"
                >
                  ✅ Phone No - {{ basketData.phoneNumber }}
                </p> -->
                <p class="mb-2 text-success">
                  ✅ Serial No -
                  {{ basketData.itemSerialNumber || basketData.serialNumber }}
                </p>
                <p class="mb-2 text-success">
                  ✅ Phone No -
                  {{
                    basketData.phoneNumber || basketData.pairedItemSerialNumber
                  }}
                </p>
              </div>
              <basket
                v-for="(data, i) in basketData.planData"
                :key="i"
                title="Bundle"
                :detailsHtml="data.text"
                :discountedPrice="data.finalPrice"
                :currencySymbol="data.currencySymbol"
                :originalPrice="data.price"
                buttonType="change"
                buttonLabel="Change"
                :planName="data.planName"
                @action="changePlan"
                :promoDetails="data.promodata"
              />
              <basket
                v-for="(data, i) in basketData.addonData"
                :key="i"
                title="Addon"
                :detailsHtml="data.text"
                :discountedPrice="data.finalPrice"
                :originalPrice="data.price"
                buttonType="change"
                buttonLabel="Change"
                :planName="data.planName"
                @action="changePlan"
              />
              <p
                class="mb-2 mt-2 text-success"
                v-if="basketData.shippingCharge"
              >
                ✅ Shipping Charge:
                {{ basketData.shippingCharge }}
              </p>
              <div class="text-gray-700 font-semibold">
                {{ $t("customers.label.TotalPrice") }}
                <span style="color: green"
                  >{{ basketData.planData[0].currencySymbol
                  }}{{ basketData.totalPrice.toFixed(2) }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row justify-end">
      <span class="mr-2 mt-2">
        <vs-button @click="nextTab">
          {{ $t("customers.label.next") }}
        </vs-button>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import basket from "@/components/basket.vue";
import vSelect from "vue-select";
import Timer from "@/components/Timer.vue";
import moment from "moment";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import TermsAndConditions from "@/components/termCondition.vue";
import Vue from "vue";
import Datepicker from "vuejs-datepicker";
import VeeValidate, { Validator } from "vee-validate";

Vue.use(VeeValidate);

Validator.extend("adult", {
  getMessage: (field) => `You must be at least 18 years old to register.`,
  validate: (value) => {
    if (!value) return false;

    const birthDate = new Date(value);
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    return (
      age > 18 ||
      (age === 18 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)))
    );
  },
});

export default {
  components: {
    basket,
    "v-select": vSelect,
    TermsAndConditions,
    Timer,
    ValidationProvider,
    ValidationObserver,
    Datepicker,
  },
  data() {
    return {
      titleOptions: [
        { label: "Mr.", value: "Mr." },
        { label: "Mrs.", value: "Ms." },
        { label: "Dr.", value: "Dr." },
      ],
      postcode: "",
      countryName: "",
      userChangePassword: false,
      prepaidSections: [
        {
          id: 1,
          title: "Customer Information",
          open: false,
        },
        {
          id: 2,
          title: "Mailing Address",
          open: false,
        },
      ],
      sections: [
        {
          id: 1,
          title: "Customer Information",
          open: false,
        },
        {
          id: 2,
          title: "Mailing Address",
          open: false,
        },
        {
          id: 3,
          title: "Spend Cap",
          open: false,
        },
        {
          id: 4,
          title: "Billing Cycle",
          open: false,
        },
      ],
      customerForm: {
        title: "",
        initials: "",
        firstName: "",
        lastName: "",
        email: "",
        contactNumber: "",
        dob: "",
        language: "",
        referral: "",
      },
      addressObj: {
        addressNo: "",
        city: "",
        state: "",
        country: "",
        district: "",
        zipCode: "",
        addressType: "",
        residentPeriod: "",
      },
      addressForm: {
        postCode: "",
        country: "",
        city: "",
        street: "",
        residentPeriod: "",
      },
      clientData: {
        activationDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        entryType: "IND",
        officeId: 7,
        clientCategory: 1,
        title: "",
        firstname: "",
        lastname: "",
        phone: "",
        email: "",
        vipId: -1,
        disabilityId: -1,
        locale: "en",
        active: true,
        dateFormat: "dd MMMM yyyy",
        district: "",
        flag: false,
        // billMode: "both",
        address: [
          {
            addressNo: "",
            city: "",
            state: "",
            country: "",
            district: "",
            zipCode: "",
            addressType: "PRIMARY",
          },
          {
            addressNo: "",
            city: "",
            state: "",
            country: "",
            district: "",
            zipCode: "",
            addressType: "BILLING",
          },
        ],
        idKey: 1,
        idValue: "0987653789708",
        gender: 1,
        dateOfBirth: "",
        nationalityId: 103,
        // type: "postpaid",
        // invoiceType: "Summary",
        // billSuppressionFlag: "N",
        // fiscalYear: 576,
        // fiscalQuarter: 574,
        // billModes: "E-invoice",
        // billDayOfMonth: 1,
      },
      termsAccepted: false,
      wantSpendCap: false,
      termCondtionPopup: false,
      amounts: [
        { value: 2500000, label: "250" },
        { value: 5000000, label: "500" },
        { value: 10000000, label: "1000" },
        { value: 20000000, label: "2000" },
      ],
      selectedAmount: 10000000,
      billGenerationDate: "",
      show: false,
      selectedAddress: "Select an address",
    };
  },
  computed: {
    ...mapState({
      addressList: (state) => state.customerActivationNew.addressByZipData,
      cityTemplateData: (state) => state.entity.cityTemplate,
      elapsedTime: (state) => state.customerActivationNew.elapsedTime,
      preferredLanguages: (state) =>
        state.customerActivationNew.preferredLanguages,
      sourceTypes: (state) => state.customerActivationNew.sourceTypes,
      billCycles: (state) => state.customerActivationNew.billCycles,
      basketData: (state) => state.customerActivationNew.basketData,
      customerInfo: (state) => state.customerActivationNew.customerInfo,
    }),
    getCustomerTemplate() {
      return this.$store.getters["customer/getClientsTemplate"];
    },
    isValid() {
      if (this.basketData.simType === "Prepaid") {
        return (
          this.clientData.title &&
          this.clientData.firstname &&
          this.clientData.lastname &&
          this.clientData.email &&
          this.clientData.phone &&
          this.clientData.dateOfBirth &&
          this.addressObj.city &&
          this.addressObj.addressNo &&
          this.addressObj.country &&
          this.addressObj.zipCode &&
          this.addressObj.district &&
          this.addressObj.state &&
          this.customerForm.language &&
          this.termsAccepted
        );
      } else {
        return (
          this.clientData.title &&
          this.clientData.firstname &&
          this.clientData.lastname &&
          this.clientData.email &&
          this.clientData.phone &&
          this.clientData.dateOfBirth &&
          this.addressObj.city &&
          this.addressObj.addressNo &&
          this.addressObj.country &&
          this.addressObj.zipCode &&
          this.addressObj.district &&
          this.addressObj.state &&
          this.customerForm.language &&
          this.termsAccepted &&
          this.billGenerationDate
        );
      }
    },
  },
  methods: {
    populateAddressFields() {
      if (this.selectedAddress != "Select an address") {
        this.addressObj.city = this.selectedAddress.City;
        this.addressObj.country = this.selectedAddress.Country;
        this.addressObj.zipCode = this.selectedAddress.PostalCode;
        this.addressObj.district = this.selectedAddress.Street;
        this.addressObj.state = this.selectedAddress.State;
        this.addressObj.addressNo = this.selectedAddress.House;
      }
    },
    enterAddressManually() {
      this.$store.dispatch("customerActivationNew/resetAddressByZipCode");
      this.clearAddressFields();
      this.show = !this.show;
    },
    enterAddressDynamically() {
      this.$store.dispatch("customerActivationNew/resetAddressByZipCode");
      this.clearAddressFields();
      this.show = this.show;
    },
    clearAddressFields() {
      this.addressObj = {
        addressNo: "",
        city: "",
        state: "",
        country: "",
        district: "",
        zipCode: "",
        addressType: "",
        residentPeriod: "",
      };
      this.selectedAddress = "Select an address";
      this.show = false;
    },
    fetchAddressList() {
      this.clearAddressFields();
      const payload = {
        address: this.postcode,
        country: this.countryName,
      };
      this.$store.dispatch("customerActivationNew/addressByZipCode", payload);
    },
    updateElapsedTime(time) {
      this.$store.commit("customerActivationNew/setElapsedTime", time);
    },
    toggleSection(id) {
      const section = this.sections.find((sec) => sec.id === id);
      if (section) section.open = !section.open;
      const section1 = this.prepaidSections.find((sec) => sec.id === id);
      if (section1) section1.open = !section1.open;
    },
    submitForm() {
      //
    },
    changeSpendCapType(val) {
      if (val) this.selectedAmount = null;
    },
    async getTemplate() {
      try {
        await this.$store.dispatch("customer/setSaleTemplate");
        this.$store.dispatch("customerActivationNew/setPreferredLanguages");
        this.$store.dispatch("customerActivationNew/setSourceTypes");
        this.$store.dispatch("customerActivationNew/setBillCycles");
        this.$store.dispatch("customer/setClientTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    handleAction() {},
    selectAmount(amount) {
      this.selectedAmount = amount;
    },
    changePlan() {
      this.$router.push("/customers/customer_activation/plan-info");
    },
    async nextTab() {
      const isValid = await this.$refs.customerInfoObserver.validate();
      if (!isValid || !this.termsAccepted) {
        this.$swal({
          title: "Error",
          text: "Please fill all the required fields and accept terms and conditions",
          icon: "error",
        });
        return;
      }
      //
      let custInfo = {
        activationDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        title: this.clientData.title,
        firstname: this.clientData.firstname,
        lastname: this.clientData.lastname,
        email: this.clientData.email,
        phone: this.clientData.phone,
        dob: moment(this.clientData.dateOfBirth).format("YYYY-MM-DD 00:00:00"),
        preferredLanguage: this.customerForm.language,
        addressNo: this.addressObj.addressNo,
        residentPeriod: this.addressObj.residentPeriod,
        city: this.addressObj.city,
        state: this.addressObj.state,
        country: this.addressObj.country,
        district: this.addressObj.district,
        zipCode: this.addressObj.zipCode,
        // addressType: this.addressObj.addressType,
        planCode: this.basketData.planData[0].planId,
        contractPeriod: parseInt(this.basketData.planData[0].contractPeriodId),
        paytermCode: "1 Month",
        start_date: moment().format("YYYY-MM-DD HH:mm:ss"),
        billingCycle:
          this.basketData.simType === "Postpaid" ? this.billGenerationDate : 1,
        spendCap:
          this.basketData.simType === "Postpaid" ? this.selectedAmount : 0,
        initials: this.customerForm.initials,
        referral: this.customerForm.referral,
        selectedAddress: this.selectedAddress,
        termsAccepted: this.termsAccepted,
      };
      this.$store.dispatch(
        "customerActivationNew/customerActivationCustInfo",
        custInfo
      );
      this.$router.push("/customers/customer_activation/contract-review");
    },
  },
  async mounted() {
    await this.getTemplate();
    if (this.customerInfo && Object.keys(this.customerInfo).length === 0) {
      return;
    } else {
      this.clientData.title = this.customerInfo.title;
      this.clientData.firstname = this.customerInfo.firstname;
      this.clientData.lastname = this.customerInfo.lastname;
      this.customerForm.initials = this.customerInfo.initials;
      this.clientData.email = this.customerInfo.email;
      this.clientData.phone = this.customerInfo.phone;
      this.customerForm.language = this.customerInfo.preferredLanguage;
      this.customerForm.referral = this.customerInfo.referral;
      this.addressObj.addressNo = this.customerInfo.addressNo;
      this.addressObj.residentPeriod = this.customerInfo.residentPeriod;
      this.addressObj.city = this.customerInfo.city;
      this.addressObj.state = this.customerInfo.state;
      this.addressObj.country = this.customerInfo.country;
      this.addressObj.district = this.customerInfo.district;
      this.addressObj.zipCode = this.customerInfo.zipCode;
      this.clientData.dateOfBirth = this.customerInfo.dob;
      this.selectedAddress = this.customerInfo.selectedAddress;
      this.termsAccepted = this.customerInfo.termsAccepted;
      this.basketData.planData[0].planId = this.customerInfo.planCode;
      this.billGenerationDate =
        this.basketData.simType === "Postpaid"
          ? this.customerInfo.billingCycle
          : 1;
      this.selectedAmount =
        this.basketData.simType === "Postpaid" ? this.customerInfo.spendCap : 0;
    }
  },
};
</script>

<style scoped>
input[type="checkbox"]:focus {
  outline: none;
  box-shadow: none;
}
select {
  height: 36px !important;
}
input {
  height: 36px !important;
}
.container {
  width: 100%;
  margin: 0 auto;
  padding: 24px;
  background-color: white;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.bg-gray-100 {
  background-color: #f7f7f7;
}

/* . {
  background-color: #fafafa;
} */

.text-blue-500 {
  color: #3b82f6;
}

.text-blue-500:hover {
  text-decoration: underline;
}

input,
select {
  border: 1px solid #d1d5db;
  padding: 0.5rem;
  border-radius: 0.375rem;
}

input:focus,
select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}

.basket_popup {
  width: 500px;
}

.basketSection {
  border-bottom: 1px solid #00000026;
  padding-bottom: 10px;
  margin-bottom: 15px;
}

.amount-selector {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.amount-box {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 40px;
  font-size: 16px;
  font-weight: 400;
  background-color: #f0f9ff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.amount-box:hover {
  box-shadow: 0px 0px 10px 0px #00000033;
}

.cap-bg {
  background: #fff4d7;
}

.amount-box.selected {
  background-color: #e0f7ec;
  border-color: #10b981;
  box-shadow: 0px 0px 10px 0px #00000033;
  color: #047857;
}

.billGenerationSection {
  height: 178px;
}
</style>
